import React from 'react';
import Card from '@material-ui/core/Card/Card';
import CardActions from '@material-ui/core/CardActions/CardActions';
import CardContent from '@material-ui/core/CardContent/CardContent';
// import CardMedia from '@material-ui/core/CardMedia/CardMedia';
import FormControl from '@material-ui/core/FormControl/FormControl';
import Grid from '@material-ui/core/Grid/Grid';
// import InputLabel  from '@material-ui/core/InputLabel/InputLabel';
// import Select  from '@material-ui/core/Select/Select';
import TextField from '@material-ui/core/TextField/TextField';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import ButtonSubmit from '../components/ButtonSubmit';
// import ImageLogin from '../imgs/login.jpg';
import { MsgError } from '../components/Message';
import HttpAgent from '../myapi';
// import { withRouter  from 'react-router';
import Auth from './Auth';
// import axios from 'axios';

const styles = {
    container: {
        marginTop: 120,
    },
    card: {
        maxWidth: 345,
        backgroundColor: 'rgba(255,255,255, .7)',
    },
};

class LoginPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uname: '',
            pswd: '',
            processing: false,
            failed: false,
            userRoles: [],
        };
    }

    submit = e => {
        e.preventDefault();
        // this.setState({ processing: true });

        const send = {
            unm: this.state.uname,
            psw: this.state.pswd,
        };
        HttpAgent.login('/Login/doLogin', send).then(res => {
            if (res.sts === '*') {
                //SAVE IN LOCALSTORAGE
                Auth.loginSuccess(res.l);

                //REDIRECT TO HOME PAGE
                this.props.history.replace('/Dash');
            } else {
                this.setState({ failed: true, pswd: '' });
            }
        });
    };
    componentDidMount() {
        Auth.clearLog();
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    render() {
        const { uname, pswd } = this.state;
        const formFilled = uname.length && pswd.length;

        const { classes } = this.props;
        return (
            <Grid className={classes.container} item>
                <form noValidate autoComplete="off">
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="h2"
                            >
                                Login
                            </Typography>

                            <FormControl
                                fullWidth
                                className={classes.formControl}
                            >
                                <TextField
                                    label="Username"
                                    className={classes.textField}
                                    value={uname}
                                    onChange={this.handleChange('uname')}
                                    margin="normal"
                                />
                            </FormControl>

                            <FormControl
                                fullWidth
                                className={classes.formControl}
                            >
                                <TextField
                                    type="password"
                                    label="Password"
                                    className={classes.textField}
                                    value={pswd}
                                    onChange={this.handleChange('pswd')}
                                    margin="normal"
                                />
                            </FormControl>
                        </CardContent>
                        <CardActions>
                            {this.state.failed && (
                                <MsgError msg="Login Failed" />
                            )}
                            <ButtonSubmit
                                label="Login"
                                formFilled={formFilled}
                                processing={this.state.processing}
                                submitFn={this.submit}
                            />
                        </CardActions>
                    </Card>
                </form>
            </Grid>
        );
    }
}

// export default withRouter(withStyles(styles)(LoginPanel));
export default withStyles(styles)(LoginPanel);
